module.exports = __webpack_public_path__ + "static/img/other-danxuanti.f87db993.png";